
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/site/learn",
      function () {
        return require("private-next-pages/site/learn/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/site/learn"])
      });
    }
  